import messages from '../messages.js';

export const LOCATION_TYPE_PREMISES = 1;
export const LOCATION_TYPE_VIDEO = 2;
export const LOCATION_TYPE_CHOOSE = 3;

export const OPTIONS = [
  { value: LOCATION_TYPE_PREMISES, label: messages.onPremises },
  { value: LOCATION_TYPE_VIDEO, label: messages.videoMeeting },
  { value: LOCATION_TYPE_CHOOSE, label: messages.parentsChoose },
];

export const LOCATION_TYPE_LABEL = OPTIONS.reduce((acc, opt) => ({ ...acc, [opt.value]: opt.label }), {});
